export class FileModel {
  public id: number;
  public path: string;
  public filename: string;
}
